var _defs, _circle, _g, _g2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCredit = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "w-12 h-12",
  viewBox: "0 0 100 100",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: "50%",
  cy: "50%",
  r: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#0d9488"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0f766e"
})), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: "140%",
  height: "140%",
  x: "-20%",
  y: "-20%"
}, /*#__PURE__*/React.createElement("feDropShadow", {
  dx: 1,
  dy: 1,
  floodColor: "#000",
  floodOpacity: 0.5,
  stdDeviation: 1.2
})))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 48,
  fill: "#0f766e"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#134e4a",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 2v16M62.423 3.636l-4.14 15.454M74 8.43l-8 13.857M83.941 16.059 72.627 27.373M91.57 26l-13.857 8M96.364 37.577l-15.454 4.14M98 50H82M96.364 62.423l-15.454-4.14M91.57 74l-13.857-8M83.941 83.941 72.627 72.627M74 91.57l-8-13.857M62.423 96.364l-4.14-15.454M50 98V82M37.577 96.364l4.14-15.454M26 91.57l8-13.857M16.059 83.941l11.314-11.314M8.43 74l13.857-8M3.636 62.423l15.454-4.14M2 50h16M3.636 37.577l15.454 4.14M8.43 26l13.857 8M16.059 16.059l11.314 11.314M26 8.43l8 13.857M37.577 3.636l4.14 15.454"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("path", {
  d: "m56.265 2.41-2.088 15.864M68.369 5.654l-6.123 14.782M79.22 11.919l-9.74 12.694M88.081 20.78l-12.694 9.74M94.346 31.631l-14.782 6.123M97.59 43.735l-15.864 2.088M97.59 56.265l-15.864-2.088M94.346 68.369l-14.782-6.123M88.081 79.22l-12.694-9.74M79.22 88.081l-9.74-12.694M68.369 94.346l-6.123-14.782M56.265 97.59l-2.088-15.864M43.735 97.59l2.088-15.864M31.631 94.346l6.123-14.782M20.78 88.081l9.74-12.694M11.919 79.22l12.694-9.74M5.654 68.369l14.782-6.123M2.41 56.265l15.864-2.088M2.41 43.735l15.864 2.088M5.654 31.631l14.782 6.123M11.919 20.78l12.694 9.74M20.78 11.919l9.74 12.694M31.631 5.654l6.123 14.782M43.735 2.41l2.088 15.864"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 40,
  fill: "url(#a)"
})), /*#__PURE__*/React.createElement("text", {
  x: "50%",
  y: "55%",
  fill: "#fff",
  dominantBaseline: "middle",
  filter: "url(#b)",
  fontFamily: "Georgia, serif",
  fontSize: 65,
  fontWeight: 900,
  letterSpacing: 2,
  style: {
    fontSize: 57
  },
  textAnchor: "middle"
}, "\n    C\n  "));
export { SvgCredit as ReactComponent };
export default __webpack_public_path__ + "assets/images/credit.svg";